<template>
	<div class="m-banner">
		<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == currentBanner}">
			<a>
				<sub-image class="image" :src="item.img_url" mode="aspectFill"></sub-image>
			</a>
		</div>
		
		<div class="nav">
			<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == currentBanner}"></div>
		</div>
		
		<div class="classify"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {},
				currentBanner: 0
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-banner {
		position: relative;
		height: 570px;
		overflow: hidden;
		
		> .item {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			height: 570px;
			text-align: center;
			opacity: 0;
			transition: opacity .3s ease;
			
			&.z-crt {
				z-index: 1;
				opacity: 1;
			}
			
			.image {
				position: relative;
				left: 50%;
				min-width: 2400px;
				height: 570px;
				transform: translate(-50%,0);
			}
		}
		
		.nav {
			z-index: 1;
			position: absolute;
			left: 50%;
			bottom: 28px;
			font-size: 0;
			transform: translate(-50%,0);
			
			.item {
				display: inline-block;
				width: 60px;
				height: 3px;
				margin: 0 10px;
				background: #000;
				opacity: .5;
				transition: all .3s ease;
				cursor: pointer;
				
				&.z-crt {
					background: #fff;
					opacity: 1;
				}
			}
		}
		
		.classify {
			z-index: 2;
			position: absolute;
			left: 50%;
			top: 25px;
			bottom: 25px;
			width: 200px;
			margin-left: -700px;
			background: #fff;
		}
	}
</style>
